"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateGridColumn = exports.NUMBER_OF_COLUMNS = exports.LAST_COLUMN_POSITION = exports.GRID_COLUMN_FULL_WIDTHS = exports.FIRST_COLUMN_POSITION = void 0;
/** Number of columns a cell may span */

/** Column number to begin a cell at */

/** The number of columns */
var NUMBER_OF_COLUMNS = 12;
/** Position of the first column, 1-based */
exports.NUMBER_OF_COLUMNS = NUMBER_OF_COLUMNS;
var FIRST_COLUMN_POSITION = 1;
/** Position of the last column, 1-based */
exports.FIRST_COLUMN_POSITION = FIRST_COLUMN_POSITION;
var LAST_COLUMN_POSITION = NUMBER_OF_COLUMNS + 1;
exports.LAST_COLUMN_POSITION = LAST_COLUMN_POSITION;
var normalizeValue = function normalizeValue(_ref) {
  var left = _ref.left,
    right = _ref.right,
    fallback = _ref.fallback;
  if (typeof left === "undefined") return [];

  // If we have responsive values for `right`, then we presumably
  // want to keep the `left` the same across them
  if (typeof left === "number" && typeof right !== "number" && typeof right !== "undefined") {
    return [left];
  }

  // If we have a single value for `left`, collapse it to full-width at
  // the mobile breakpoint, otherwise respect the responsive values.
  return typeof left === "number" ? [fallback, left] : left;
};
var valueAtOrLast = function valueAtOrLast(xs, i) {
  return xs[i] !== null && xs[i] !== undefined ? xs[i] : xs[xs.length - 1];
};

/**
 * Builds a value for `gridColumn` based on the assumptions laid out
 * by our 12-column grid.
 */
var calculateGridColumn = function calculateGridColumn(_ref2) {
  var columnSpan = _ref2.span,
    columnStart = _ref2.start;
  var spans = normalizeValue({
    left: columnSpan,
    right: columnStart,
    fallback: NUMBER_OF_COLUMNS
  });
  var starts = normalizeValue({
    left: columnStart,
    right: columnSpan,
    fallback: FIRST_COLUMN_POSITION
  });

  // Nothing set, return default
  if (spans.length === 0 && starts.length === 0) {
    return [];
  }

  // More starts than spans, favor start
  if (starts.length > spans.length) {
    return starts.map(function (start, i) {
      var span = valueAtOrLast(spans, i);
      if (span && span + start > LAST_COLUMN_POSITION) {
        throw new Error("`span` and `start` must fit within the grid");
      }
      return span ? "".concat(start, " / span ").concat(span) : "".concat(start, " / -1");
    });
  }

  // Starts and spans, or spans and the only start
  return spans.map(function (span, i) {
    var start = valueAtOrLast(starts, i);
    if (start && start + span > LAST_COLUMN_POSITION) {
      throw new Error("`span` and `start` must fit within the grid");
    }
    return start ? "".concat(start, " / span ").concat(span) : "span ".concat(span);
  });
};

/** Hardcoded list of full-width column spans */
exports.calculateGridColumn = calculateGridColumn;
var GRID_COLUMN_FULL_WIDTHS = ["1 / -1", "1 / 12", "1 / span 12", "span 12"];
exports.GRID_COLUMN_FULL_WIDTHS = GRID_COLUMN_FULL_WIDTHS;
//# sourceMappingURL=calculateGridColumn.js.map